import { Loader } from "lucide-react";
import type React from "react";

type AppProps = {
	width?: number;
	className?: string;
};
const Spinner: React.FunctionComponent<AppProps> = ({ width,className }) => {
	return <Loader size={width || 30} className={`${className} animate-spin` } />;
};

export default Spinner;
